import { render, staticRenderFns } from "./ColorPickerPipette.vue?vue&type=template&id=5bb9d8fc&scoped=true&"
import script from "./ColorPickerPipette.vue?vue&type=script&lang=ts&"
export * from "./ColorPickerPipette.vue?vue&type=script&lang=ts&"
import style0 from "./ColorPickerPipette.vue?vue&type=style&index=0&id=5bb9d8fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb9d8fc",
  null
  
)

export default component.exports